import { fetchAuthSession } from "aws-amplify/auth";
import { post, put, del } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";
import {
  IMAGING_QUERY_KEY,
  MEDIA_QUERY_KEY,
  DOCUMENTS_QUERY_KEY,
} from "./useImagingAndLabsQuery";

export const useImagingPostDocumentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (documentFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "hrapilabsimaging",
        path: `/documents`,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: documentFormInputs,
        },
      }).response;
      return (await body?.json()) || {};
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [IMAGING_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [DOCUMENTS_QUERY_KEY] });
    },
  });
};

export const useImagingPutDocumentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (documentFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: "hrapilabsimaging",
        path: "/documents",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: documentFormInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [IMAGING_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [DOCUMENTS_QUERY_KEY] });
    },
  });
};

export const useImagingDeleteDocumentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const session = await fetchAuthSession();
      const { body } = await del({
        apiName: "hrapilabsimaging",
        path: `/documents`,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          queryParams: { id: id },
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [IMAGING_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [DOCUMENTS_QUERY_KEY] });
    },
  });
};

export const useImagingPostDocumentMediaMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (mediaFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "hrapilabsimaging",
        path: `/documents/media`,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: mediaFormInputs,
        },
      }).response;
      return (await body?.json()) || {};
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [MEDIA_QUERY_KEY] });
    },
  });
};
